<template>
  <div class="fixed mt-5" id="pendingactivities">
    <div class=" col-9 pl-2 pr-2 card borderradius20 mr-4 ml-5 d-none d-lg-block d-xl-block jobSec" v-if="currentUserProfileId">
      <div class="card-body p-3">
        <div class="row no-gutters">
          <div class="col fontsize14 proximanova pointer" @click="lookingForAJobChange">Looking for a job change</div>
          <div class="custom-control custom-switch" @click="lookingForAJobChange">
            <input
              type="checkbox"
              v-model="jobchange"
              class="custom-control-input pointer"
              id="switch1"
              true-value = "Y"
              false-value = "N"
              name="example"
            />
            <label class="custom-control-label" for="switch1"></label>
          </div>
        </div>
        <div class="col-12 mt-4 mb-4 text-center" v-if="loadingJobListOptions">
          <img src="../assets/loading2.svg" width="35px" height="35px" alt="loadinganimation">
        </div>
        <div v-else>
        <div class="col-12 p-0 d-md-flex flex-wrap" v-if="jobchange == 'Y'">
          <div class="col-6 pl-0 d-flex mt-2" v-for="(option, index) in jobChangeOptinsList" :key="index">
            <input type="checkbox" name="applicant selection" class="my-auto" v-model="option.activeStatus" true-value="Y" false-value="N" :id="'jobchangetype'+index" :value="option.activeStatus" @click="checkboxSelected(option, index)">
            <label class="proximanova fontsize13 black80 my-auto ml-2" :for="'jobchangetype'+index" >{{option.indexDetailName}}</label>
          </div>
        </div>
        <div class="col-12 text-center" v-if="jobchange == 'Y' && selectedJobChangeList.length>0">
          <img src="../assets/uploadvideo.svg" v-if="submitjobchangeLoading" class="mt-3" width="30px" height="30px" alt="loadinganimation">
          <button v-else @click="submitJobChangeData" class="bordernone mt-3 btn button-create proximanova fontsize13 p-1 pl-3 pr-3 backgroundcolorblack mouseoverbtn2 borderradius20 white">Submit</button>
        </div>
        </div>
      </div>
    </div>
    <div
      v-if="showpending"
      class="col-9  card borderradius20 ml-5 mt-3 mr-4 d-none d-lg-block d-xl-block pendingSec"
    >
      <div class="card-body pending">
        <div class="row no-gutters">
          <div class="col">
            <label class="fontsize12 proximanova black60  ml-3">Pending Activities</label>
            <img
              src="../assets/Close.svg"
              class="img-fluid float-right mt-1 mr-2"
              alt="close"
              @click="pending()"
            />
          </div>
        </div>
        <div class="card backgroundcolorwhite border-0 borderradius10 mt-2" v-if="!currenteUser.resumeVideoId">
          <div class="d-flex justify-content-between p-2">
            <div class="d-flex col-9 pl-0 pr-0">
              <img src="../assets/VideoResume.svg" alt="video" width="22px" class="mr-2 my-auto" />
              <div class="d-flex flex-column">
                <label class="proximanova-semibold black80 my-auto fontsize12">Video Resume</label>
                <span class="fontsize10 proximanova black30 mt-0">it increases your profile strength</span>
              </div>
            </div>
            <button class="pendingmouseover border-0 borderradius5 pl-2 pr-2 proximanova my-auto" @click="VideoResumeModalOpen">Create</button>
          </div>
        </div>
        <div class="card backgroundcolorwhite border-0 borderradius10 mt-2" v-if="currenteUser.profileVideoId == null">
          <div class="d-flex justify-content-between p-2">
            <div class="d-flex col-9 pl-0 pr-0">
              <img src="../assets/VideoResume.svg" alt="video" width="22px" class="mr-2 my-auto" />
              <div class="d-flex flex-column">
                <label class="proximanova-semibold black80 my-auto fontsize12">Video Profile</label>
                <span class="fontsize10 proximanova black30 mt-0">it increases your profile strength</span>
              </div>
            </div>
            <button class="pendingmouseover border-0 borderradius5 pl-2 pr-2 proximanova my-auto" @click="VideoProfileModalOpen">Create</button>
          </div>
        </div>
        <div class="card backgroundcolorwhite border-0 borderradius10 mt-2" v-if="!currenteUser.profileId">
          <div class="d-flex justify-content-between p-2">
            <div class="d-flex col-9 pl-0 pr-0">
              <img src="../assets/ProfileDetails.svg" alt="video" width="22px" class="mr-2 my-auto" />
              <div class="d-flex flex-column">
                <label class="proximanova-semibold black80 my-auto fontsize12">Profile Details</label>
                <span class="fontsize10 proximanova black30 mt-0">it increases your profile strength</span>
              </div>
            </div>
            <button class="pendingmouseover border-0 borderradius5 pl-2 pr-2 proximanova my-auto" @click="changecreateprofileImage">Create</button>
          </div>
        </div>
        <!-- <div class="card backgroundcolorwhite border-0 borderradius10 mt-2" >
          <div class="d-flex justify-content-between p-2">
            <div class="d-flex col-9 pl-0 pr-0">
              <img src="../assets/worknotion_profilelinks.svg" alt="video" width="22px" class="mr-2 my-auto" />
              <div class="d-flex flex-column">
                <label class="proximanova-semibold black80 my-auto fontsize12">User Links</label>
                <span class="fontsize10 proximanova black30 mt-0">it increases your profile strength</span>
              </div>
            </div>
            <button class="pendingmouseover border-0 borderradius5 pl-2 pr-2 proximanova my-auto" @click="AddLinkModal">Create</button>
          </div>
        </div>
        <div class="card backgroundcolorwhite border-0 borderradius10 mt-2" >
          <div class="d-flex justify-content-between p-2">
            <div class="d-flex col-9 pl-0 pr-0">
              <img src="../assets/worknotion_profileservices.svg" alt="video" width="22px" class="mr-2 my-auto" />
              <div class="d-flex flex-column">
                <label class="proximanova-semibold black80 my-auto fontsize12">User Services</label>
                <span class="fontsize10 proximanova black30 mt-0">it increases your profile strength</span>
              </div>
            </div>
            <button class="pendingmouseover border-0 borderradius5 pl-2 pr-2 proximanova my-auto" @click="AddServiceModal">Create</button>
          </div>
        </div>
        <div class="card backgroundcolorwhite border-0 borderradius10 mt-2" >
          <div class="d-flex justify-content-between p-2">
            <div class="d-flex col-9 pl-0 pr-0">
              <img src="../assets/worknotion_profilebatches.svg" alt="video" width="22px" class="mr-2 my-auto" />
              <div class="d-flex flex-column">
                <label class="proximanova-semibold black80 my-auto fontsize12">User Badges</label>
                <span class="fontsize10 proximanova black30 mt-0">it increases your profile strength</span>
              </div>
            </div>
            <button class="pendingmouseover border-0 borderradius5 pl-2 pr-2 proximanova my-auto" @click="AddBadgeModal">Create</button>
          </div>
        </div> -->
        <div class="column pdtext">
          <div class="row ">
            <div class="hr-theme-slash-2 col-12">
              <div class="hr-line"></div>
            </div>
          </div>
          <span class="text-center fontsize10 proximanova black60">
            Your Profile strength is
            <strong>{{profileStrengthLabel}}</strong>, complete your
            pending activities to keep your profile strong
          </span>
        </div>
      </div>      
    </div>
    <add-badge-modal  v-if="openAddBadgeModal" :profileresume="profileresumeobj" @close = "closeModal"></add-badge-modal>
        <add-service-modal v-if="openAddServiceModal" :userServiceList="userServiceList" @closeservicemodal="closeservicemodal"></add-service-modal>
        <add-link-modal   v-if="openAddLinkModal" :userLinksList="userLinksList" @closebadgemodal="closeLinkModal"></add-link-modal>
    <profileresumemodal v-if="profileresumemodalopen" :profileresume="profileresumeobj" @close = "closeModal"></profileresumemodal>
    <div class="col-10 mr-4 ml-4  d-none d-lg-block d-xl-block suggSec" v-if=" (this.currentRoute !== 'People' && this.currentRoute !== 'searchResults') && suggestedPeople.length > 0">
      <div class="d-flex flex-column ml-2" v-if="hidesuggestedPeoplesection">
        <div class="col">
          <label class="fontsize20 proximanova black80 pt-4">Suggested People</label>
        </div>
        <div class="d-flex flex-column">
          <div v-for="(user,index) in suggestedPeople" :key="index">
            <div class="d-flex justify-content-between" id="suggested-list" @mouseover="mouseOverSuggestedPeople(index)" @mouseleave="mouseLeaveSuggestedPeople(index)" v-if="user.followingFlag === 'N' && index < 10">
              <div class="d-flex p-2 ml-2 mr-2" >
                <div>
                  <!-- <img v-if="!user.profilePictureLink" id="noprofImage" class="img-fluid rounded-circle profile-border"  src="../assets/Profile_placehlder.svg" /> -->
                  <div v-if="!user.profilePictureLink" id="profImage1" class=" text-center white fontsize14 profile-border rounded-circle white" :class="user.firstName.charAt(0)">
                      <span class="white fontsize14 text-uppercase">{{user.firstName.charAt(0)}}</span>
                  </div>
                  <div v-else class="profile-border">
                    <img  :src="user.profilePictureLink" id="profImage" alt="profilepic" class="img-fluid rounded-circle loadingBgImg" @error="ErrorwithProfilePic(user)">
                  </div> 
                </div>
                <div class="d-flex flex-column pl-2 pr-2 mt-0 text-capitalize">                 
                  <span class="fontsize14 proximanova black nameBlock"  @click="selectedUser(user.aliasLink)">{{user.fullName.substr(0,12)}}<span v-if="user.fullName.length>12">...</span></span>
                  <span class="fontsize12 proximanova black60 flex-wrap pr-2" >{{user.subcontent.substr(0,16)}}...</span>
                </div>
              </div>
              <div class="my-auto">
                <button :disabled="user.disablefollowBtn" class="bordernone btn button-create proximanova fontsize12 p-1 pl-3 pr-3 backgroundcolorblack mouseoverbtn2 borderradius20 white" v-if="user.followingFlag === 'Y' && user.profile !== currentUserProfileId" @click="Unfollow(user.profileId, user)">UnFollow</button>
                <button :disabled="user.disablefollowBtn" class="bordernone btn button-create proximanova fontsize12 p-1 pl-3 pr-3 backgroundcolorblack mouseoverbtn2 borderradius20 white"  v-if="user.followingFlag === 'N' && user.profile !== currentUserProfileId" @click="followUser(user.profileId, user)">Follow</button>
              </div>
              <img src="../assets/Close.svg" v-if="user.showClose" alt="close" class="img-fluid closebtn float-right hover" @click="closeSuggestedPeople(index)">
            </div>
          </div>
        </div>
        <div class="left mb-4" id="more-button" @click="routetosuggestedpage('suggested')">
              <label class="fontsize20 proximanova black80 ml-3">More...</label>              
            </div>
      </div>
    </div>    
    <no-profile-id-modal-component v-if="displayNoProfileModalComponent" @closeNoProfileIdModal="closeNoProfileIdModal"></no-profile-id-modal-component>
    <APIerrorModal v-if="displayAPIerrorModal" @closeAPIerrorModal="closeAPIerrorModal"></APIerrorModal>
  </div>
</template>
<script>
import httpuserprofile from "@/js/http-userprofile.js";
import sessionUtils from '@/js/session-util.js'
import commonUtils from "../js/common-utils";
import profileresumemodal from '../components/profileResumeModal.vue'
import NoProfileIdModalComponent from '../components/NoprofileIdModal.vue'
import AddBadgeModal from '../components/AddBadgeModal.vue'
import AddServiceModal from '../components/AddServiceModal.vue'
import AddLinkModal from '../components/AddUserLinksModal.vue'
import APIerrorModal from './APIerrorpopup.vue'
import { bus } from "../main";
import router from '../router.js'
import $ from 'jquery'
export default {
  data() {
    return {
      jobchange: "N",
      loadingJobListOptions : false,
      jobChangeOptinsList : [],
      selectedJobChangeList : [],
      submitjobchangeLoading : false,
      showpending: false,
      currentUserProfileId: null,
      suggestedPeople: [],
      city1: '',
      currentRoute : '',
      currentUserId: null,
      currenteUser: null,
      disablefollowBtn : false,
      profileresumemodalopen : false,
      displayAPIerrorModal : false,
      profileId : null,
      profilePercentage : 0,
      profileStrengthLabel : "Very Low",
      openAddBadgeModal : false,
      openAddServiceModal : false,
      openAddLinkModal : false,
      userBadgeList : [],
      userServiceList : [],
      userLinksList : [],
      profileresumeobj : {},
      totalIndex : null,
      currentIndex : 1,
      displayNoProfileModalComponent : false,
      hidesuggestedPeoplesection : false,
    };
  },
  components: {
    profileresumemodal,
    NoProfileIdModalComponent,
    APIerrorModal,
    AddBadgeModal,
    AddServiceModal,
    AddLinkModal
  },
  methods: {
    closeAPIerrorModal(){
      this.displayAPIerrorModal = false;
      let body = document.getElementById("pendingactivities")
      body.classList.add('zindex5')
    },
    lookingForAJobChange(){
      if(this.currentUserProfileId){
      if(this.jobchange == 'Y'){
        this.jobchange = 'N'
      }else if(this.jobchange == 'N'){
        this.jobchange = 'Y'
      }
      if(this.jobchange == 'Y'){
        this.fetchJobChangeOptions()
      }else{
        this.selectedJobChangeList = [];
        this.submitJobChangeData()
      }
      // console.log("job change : ", this.jobchange)
      // httpuserprofile.put('/userprofile/updateUserJobStatus?profileId='+this.currentUserProfileId +'&JobStatus='+this.jobchange)
      // .then((response) => {
      //   console.log("looking for a job change : ", response)
      // }).catch((e) => {
      //   console.log(e)
      //   this.displayAPIerrorModal = true;
      // })
      }else{
        this.displayNoProfileModalComponent = true;
      }
    },
    fetchJobChangeOptions() {
      this.loadingJobListOptions = true;
      httpuserprofile.get('/userprofile/getUserJobTypeList?profileId='+this.currentUserProfileId)
      .then((response) => {
        console.log("jobchange status list : ", response.data)
        this.loadingJobListOptions = false;
        this.jobChangeOptinsList = response.data;
      }).catch((e) => {
        console.log(e.response)
        this.loadingJobListOptions = false;
      })
    },
    checkboxSelected(option, index) {
      var value = 'jobchangetype'+index;
      var element = document.getElementById(value)
      if(element.checked == true) {
        option.activeStatus = "Y";
      }else{
        option.activeStatus = "N"
      }
      var noValuePresent = false;
      if(this.selectedJobChangeList.length > 0){
        for(var i =0; i < this.selectedJobChangeList.length; i++){
          if(this.selectedJobChangeList[i].id == option.id){
            this.selectedJobChangeList[i].activeStatus = option.activeStatus;
            noValuePresent = false;
            break;
          }else{
            noValuePresent = true;
          }
        }
        if(noValuePresent) {
          this.selectedJobChangeList.push(option)
        }
      }else{
        this.selectedJobChangeList.push(option)
      }
      console.log("after adding into list : ", this.selectedJobChangeList)
    },
    submitJobChangeData() {
      this.submitjobchangeLoading = true;
      var vm = this;
      httpuserprofile.post('/userprofile/updateUserJobChangeType?profileId='+this.currentUserProfileId+'&jobChangeStatus='+this.jobchange, this.selectedJobChangeList)
      .then((response) => {
        this.submitjobchangeLoading = false;
        this.selectedJobChangeList = [];
        vm.$toast.success("Jobchange Status updated successfully")
        console.log("saved job change status : ", response)
        bus.$emit("updatedOpenToWorkData", true)
      }).catch((e) => {
        this.submitjobchangeLoading = false;
        console.log(e.response)
      })
    },
    closeNoProfileIdModal(){
      this.displayNoProfileModalComponent = false;
      let body = document.getElementById("pendingactivities")
      body.classList.add('zindex5')
    },
    // hide pending activities card section
    pending() {
      this.showpending = false;
    },
    // this will invoke after click on create resume video on pending activities card
    // open modal component where user can able to upload a resume video
    VideoResumeModalOpen : function() {
      let body = document.getElementById("pendingactivities")
      body.classList.add('zindex5')
      if(this.currentUserProfileId){
      this.profileresumemodalopen = true;
      this.profileresumeobj.videoType = "resumevid"
      }else{
        this.displayNoProfileModalComponent = true;
      }
    },
    // this will invoke after click on create profile video on pending activities card
    // open modal component where user can able to upload a profile video
    VideoProfileModalOpen : function() {
      let body = document.getElementById("pendingactivities")
      body.classList.add('zindex5')
      if(this.currentUserProfileId){
      this.profileresumemodalopen = true;
      this.profileresumeobj.videoType = "profilevid"
      }else{
        this.displayNoProfileModalComponent = true;
      }
    },
    //close profile/resume modal component
    closeModal() {
      this.profileresumemodalopen = false;
      let body = document.getElementById("pendingactivities")
      body.classList.remove('zindex5')
    },
    ErrorwithProfilePic(user) {
      user.profilePictureLink = null;
    },
    //closing the suggested people record after click on close button
    closeSuggestedPeople(index){
      this.suggestedPeople.splice(index, 1)
    },
    // mouseover /mouseleave events on suggested people to display/hide close button
    mouseOverSuggestedPeople(index){
      this.suggestedPeople[index].showClose = true;
    },
    mouseLeaveSuggestedPeople(index){
      this.suggestedPeople[index].showClose = false;
    },
    //fetching suggested people
    getSuggestedpeople(){
      httpuserprofile.get('/userprofile/getPeopleAsSuggesstionsInPeople?locations=&experience=&designation=&education=&company=&limit='+15+'&offset='+0+'&profileId='+this.currentUserProfileId+'&applyFilters=N')
        .then(response => {
         if( response.data.list){              
          response.data.list.forEach(function(d){
            d.fullName = d.firstName + ' ' + d.lastName;
            d.subcontent = d.designation;
            if(d.city){
              d.subcontent = d.subcontent+', '+d.city ;
            }
            d.showClose = false;
            d.disablefollowBtn = false;
            // d.city1 = d.city.substr(0,3);
          })
          this.suggestedPeople = response.data.list; 
          var unfollowedUsersCount = 0;   
          for(var i =0; i<this.suggestedPeople.length; i++){
            if(this.suggestedPeople[i].followingFlag === 'N'){
              unfollowedUsersCount++
            }
          }  
          if(unfollowedUsersCount > 0){
            this.hidesuggestedPeoplesection = true;
          }else{
            this.hidesuggestedPeoplesection = false;
          }  
         }
          console.log(this.suggestedPeople)
        });
    },
    //this will invoke after click on profile picture / user name
    // navigate to another page where user can able to see selected user information
    selectedUser(id){         
      this.$store.state.selectedUser = id;    
      // if(sessionUtils.getUserId() === id){
      //   if(this.currentUserProfileId) {

      //   }
      //   router.push({
      //     name : 'welcome'
      //   })
      // }else{
        this.$router.push({name: 'wn', params: { id: this.$store.state.selectedUser}});
      // }     
      //this.$router.push({name: 'wn', params: { id: this.$store.state.selectedUser}});
    },
    //follow user
    followUser(profId,user){
      user.disablefollowBtn = true;
        this.isScrolled = true;        
        httpuserprofile
            .post("/userprofile/saveFollowing?profileId="+this.currentUserProfileId+"&followingId="+profId)
            .then(response => {
              user.disablefollowBtn = false;
           this.getSuggestedpeople();       
            }).catch((e) => {
        console.log(e)
        user.disablefollowBtn = false;
        this.displayAPIerrorModal = true;
      })
        
    },
    // navigate to create profile page
    changecreateprofileImage: function(){
      this.$router.push({
        name : 'createprofile'
      })
    },
    //navigate to suggested people page when click on view more suggested people
    routetosuggestedpage:function(element){
      if(this.currentUserProfileId !== null & this.currentUserProfileId !== undefined) {
        // sessionStorage.setItem('activeElement', elementname)
        // this.$session.set("selectElement", 'people')
        // this.$session.set("activeElement", element)
        sessionUtils.setSelectedElement('people')
        this.$router.push({
          name : 'People'
        })
      }
    },
    //fetch current user information
    getUserByID(){       
        httpuserprofile
        .get("/userprofile/userbyid/" + this.currentUserId)
        .then(response => {           
          console.log(response.data)
            this.currenteUser = response.data;
            this.showpending = true;
            if(this.currenteUser.profileId && this.currenteUser.resumeVideoId && this.currenteUser.profileVideoId){
              this.showpending = false;
            }
            //profilePercentage
            this.profileId = response.data.profileId;
          if(this.profileId !== '' && this.profileId !== undefined){
            this.profilePercentage += 10; 
          }
          if(response.data.profilePictureLink !== '' && response.data.profilePictureLink !== undefined){
            this.profilePercentage += 5;
          }
          if(response.data.primaryPhoneNumber !== null && response.data.primaryPhoneNumber !== undefined) {
            this.profilePercentage += 10;
          }
          if(response.data.workExperience && response.data.workExperience.length > 0){
            this.profilePercentage += 20;
            commonUtils.updateLoginUserWorkExperience(response.data.workExperience)
          }
          if(response.data.userEducation && response.data.userEducation.length > 0) {
            this.profilePercentage += 10;
          }
          if(response.data.zipCode) {
            this.profilePercentage +=5;
          }
          if(response.data.userKnowledge && response.data.userKnowledge.length > 0 && response.data.userTechnology.length > 0){
            this.profilePercentage +=10;
          }
          if(response.data.profileVideoId !== null){
            this.profilePercentage +=15;
          }
          if(response.data.resumeVideoId !== null){
            this.profilePercentage +=15
          }
          if(response.data.jobChangeStatus){
            this.jobchange = response.data.jobChangeStatus;
            if(this.jobchange == 'Y'){
              this.fetchJobChangeOptions()
            }
          }
          this.getprofileStrengthLabel()
          // if(this.profileId){
          //   this.fetchUserBadgeList()
          //   this.fetchUserServiceList()
          //   this.fetchUserLinksList()
          // }
        }).catch((e) => {
        console.log(e)
      })   
    },
    fetchUserBadgeList : function() {
      httpuserprofile.get("/userprofile/getUserBadges?profileId="+this.profileId)
      .then((response) => {
        console.log("saved user badge list : ", response)
        if(response.data && response.data.length > 0) {
          this.userBadgeList = response.data
        }
        console.log("userbadgelist : ", this.userBadgeList)
      }).catch((e) => {
        console.log(e)
      })
    },
    fetchUserServiceList : function() {
      httpuserprofile.get("/userprofile/getUserServices?profileId="+this.profileId)
      .then((response) => {
        console.log("saved user badge list : ", response)
        if(response.data && response.data.length > 0) {
          this.userServiceList = response.data
        }
        console.log("userservicelist : ", this.userServiceList)
      }).catch((e) => {
        console.log(e)
      })
    },
    fetchUserLinksList : function() {
      httpuserprofile.get("/userprofile/getUserLinksList?userProfileId="+this.profileId)
      .then((response) => {
        console.log("saved user badge list : ", response)
        if(response.data && response.data.length > 0) {
          this.userLinksList = response.data
        }
        console.log("userbadgelist : ", this.userLinksList)
      }).catch((e) => {
        console.log(e)
      })
    },
    //badges
    AddBadgeModal : function() {
      this.openAddBadgeModal = true;
    },
    closebadgemodal : function() {
      this.openAddBadgeModal = false;
    },
    //services
    AddServiceModal : function() {
      this.openAddServiceModal = true;
    },
    closeservicemodal : function() {
      this.openAddServiceModal = false;
    },
    // links
    AddLinkModal  : function() {
      this.openAddLinkModal = true;
    },
    closeLinkModal : function() {
      this.openAddLinkModal = false;
    },
    // set the profile strength
    getprofileStrengthLabel : function() {
      //profileStrengthLabel
      if(10 <= this.profilePercentage && this.profilePercentage <= 40){
        this.profileStrengthLabel = "Very Low"
      }else if(41 <= this.profilePercentage && this.profilePercentage <= 70){
        this.profileStrengthLabel = "Average"
      }else if(71 <= this.profilePercentage && this.profilePercentage <= 90){
        this.profileStrengthLabel = "Strong"
      }else if(91 <= this.profilePercentage && this.profilePercentage <= 100){
        this.profileStrengthLabel = "All Stars"
      }
      this.$store.state.profileStrengthPercentage = this.profilePercentage;
      this.$store.state.profileStrength = this.profileStrengthLabel;
    },
     Unfollow(profId,user){    
       user.disablefollowBtn = true;
        this.isScrolled = true;     
        httpuserprofile
        .delete("/userprofile/unfollow?profileId="+this.currentUserProfileId+"&followingId="+profId)
        .then(response => {   
          user.disablefollowBtn = false;
          this.getSuggestedpeople();     
        }).catch((e) => {
        console.log(e)
        user.disablefollowBtn = false;
        this.displayAPIerrorModal = true;
      })     
    },
  },
  created(){
    this.currentUserProfileId = sessionUtils.getUserProfileId();
    this.currentRoute = this.$router.currentRoute.name;
    this.currentUserId =sessionUtils.getUserId();
    var that = this
    this.getUserByID();
    console.log(this.currentRoute, this.currentUserProfileId)
    if(this.currentRoute !== 'People' && this.currentRoute !== 'selectedUserPeople' && this.currentRoute !=='selectedCompanyPeople' && this.currentRoute !== 'searchResults' && this.currentUserProfileId && this.currentUserProfileId != "undefined"){
       this.getSuggestedpeople();
    }else{
      this.suggestedPeople = [];
    }
    bus.$on('updateProfileInformation', (data) => {
      if(data){
        that.currentUserProfileId = sessionUtils.getUserProfileId();
        this.getUserByID()
        this.getSuggestedpeople();
      }
    })
   setInterval(function(){ 
      that.profilestrengthLabel = that.$store.state.profileStrength;
    }, 1000)

  }
};
</script>
<style scoped>
.fixed{
  position: fixed;
  height: 95vh;
  overflow-y: auto;
  padding-bottom: 50px !important;
}
.fixed::-webkit-scrollbar {
  display: none;
}
.pending {
  padding: 0px 0px 0px 0px;
}
.pendingSec,
.jobSec {
  /* background-color: #e8e9eb; */
  background-color: rgba(161, 166, 179, 0.085);
  border: none;
}
.closebtn{
    position: absolute;
    right: 0;
    margin-right: 15px;
}
.loadingBgImg{
  background: transparent url('../assets/loading_gif1.gif') center no-repeat;
  background-size: 30px 30px;
}
.font14 {
  cursor: pointer;
}
#suggested-list {
  z-index: 1;
  /* position: relative; */
  /* width: 130%; */
    /* display: block; */
    /* padding: 0.5rem 0.25rem; */
    /* background-color: #fff; */
    border: none; 
    
}
#suggested-list:hover { 
  background-color:rgba(255, 255, 255,0.8);
  border-color:rgba(221, 223, 229,0.8);
  cursor: pointer; 
  border-radius: 10px;
  }
.slide-background {
  background-color: rgba(243, 244, 247, 0.5);
}
.suggSec{
  background-color: #F0F2F5;
  border: none;
}
.pendingmouseover {
  /* color: #fc597f; */
  color: black;
  font-family: "Proxima Nova";
  font-size: 14px;
  font-weight: 300;
  height: 30px;
  line-height: 30px;
  cursor: pointer;
}
.profile-border{
  padding: 1.5px;
  border: 2px solid #ced4da;
  border-radius: 50%;
}
#profImage{
  width: 35px;
  height: 35px;
  /* border:1px solid #ced4da; */
}
#profImage1{
  width: 40px;
  height: 40px;
  line-height: 34px;
}
#noprofImage{
  width: 45px;
  height: 45px;
}
.pendingmouseover:hover{
  opacity: 1 !important;
  /* background: -webkit-linear-gradient(44.51deg, #E6784F 0%, #EA5184 100%);  
  background: -moz-linear-gradient(44.51deg, #E6784F 0%, #EA5184 100%);  
  background: -o-linear-gradient(44.51deg, #E6784F 0%, #EA5184 100%);  
  background: linear-gradient(44.51deg, #E6784F 0%, #EA5184 100%);   */
  background: black !important;
  border-radius: 5px;
	/* opacity: 90% !important; */
	color: #FFFFFF !important;
}
#follow{
	transition : ease-out 0.3s;
	POSITION : relative;
	z-index : 1;
    text-align: right;
    /* right: 5%; */
    padding-left : 5px;
  padding-top: 2px;
  margin-top: 10px;
  padding-right: 5px;
  padding-bottom: 2px;
  }
  #more-button{
    cursor: pointer;
    transition : ease-out 0.3s;
	POSITION : relative;
	z-index : 1;
  cursor: pointer;
    text-align: center;
    /* right: 5%; */
    padding-left : 5px;
  padding-top: 4px;
  padding-right: 5px;

  }
  #nameBlock:hover{
color:#007AFF !important;
}
  #more-button:hover{
    cursor: pointer;
  }
   #more-button::before {
	transition : 0.5s all ease;
	position : absolute;
	top : 0;
	left : 10%;
	right : 10%;
	bottom : 0;
	opacity : 0;
	content : "";
  border-radius:20px;
	background-color :  rgba(31,31,31,.3);
  }
  #more-button:hover:before {
    cursor: pointer;
	transition : 0.5s all ease;
	left : 0;
	right : 0;
    /* padding-left:5px; */
	opacity : 1;
	z-index : -1;
    padding-bottom: 5px;    
    padding-right: 5px !important;
    padding-top: 5px !important;
    border-radius:20px;
  }
  .left{
    margin-left: 30%;
  }
  #follow:hover{
    cursor: pointer;    
  }
  .font14reg{
	color: rgba(31,31,31);
	font-family: "Proxima Nova";
	font-size: 14px;
  }
  #follow::before {
	transition : 0.5s all ease;
	position : absolute;
	top : 0;
	left : 10%;
	right : 10%;
	bottom : 0;
	opacity : 0;
	content : "";
  border-radius:20px;
	background-color :  rgba(31,31,31,.3);
  }
  #follow:hover:before {
    cursor: pointer;
	transition : 0.5s all ease;
	left : 0;
	right : 0;
    padding-left:5px;
	opacity : 1;
	z-index : -1;
    padding-bottom: 5px;    
    padding-right: 5px !important;
    padding-top: 5px !important;
    border-radius:20px;
  }
.carousel-control-next,
.carousel-control-prev {
  filter: invert(50%);
}
.carousel-inner {
  /* width: 260px; */
  width : 100%;
  padding: 1em 2.9em;
  margin-left: 2%;
}
.carousel-item {
  padding: 20%;
  /* display: block; */
}
.signleitem {
  display: block;
}
.carousel-img {
  width: 30px;
  margin-left: 42%;
}
.coloredfont12 {
  color: #fc597f;
  font-family: "Proxima Nova";
  font-size: 16px;
  font-weight: 300;
  cursor: pointer;
}
.pdtext {
  font-size: 13px;
  padding: 0 1em 1em 0;
  text-align: center;
}
.hr-theme-slash-2 {
  display: flex;
}
.hr-line {
  width: 100%;
  position: relative;
  margin: 15px;
  border-bottom: 1px solid #c5c7c9;
}
.hr-icon {
  position: relative;
  color: #757778;
  font-size: 10px;
  border: 2px solid #c5c7c9;
}
#follow{
  position: absolute;
    right: 10%;
}
</style>
